//@ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  generateCodeForDeviceRequest,
  generateCodeForDeviceSuccess,
  generateCodeForDeviceFailure,
} from '../reducer/generateCodeDeviceSlice';
import { fetchGeneratecodefordevice } from '../api'; // Assuming API paths are correct

interface generateCodeDeviceAction {
  type: typeof generateCodeForDeviceRequest.type;
}

// Fetch generate code for device saga
export function* fetchGenerateCodeDeviceRequestSaga(
  action: generateCodeDeviceAction
): Generator<any, void, unknown> {
  try {
    const generateCode: any = yield call(
      fetchGeneratecodefordevice,
      'generate_code_for_device',
      action.payload
    );
    console.log('generateCode >>>>>', generateCode);
    // If the API response has the generate Code Device under `data`, modify the structure accordingly.
    // const { statusCode } = generateCode?.response?.data;
    if (generateCode?.status === 200) {
      const response = {
        status: generateCode?.status,
      };
      yield put(generateCodeForDeviceSuccess(response)); // Assuming API response has a `status` field
    } else {
      yield put(generateCodeForDeviceFailure(generateCode));
    }
  } catch (error: any) {
    // const errorData = {
    //   status = '500',
    //   title = 'UNKNOWN_ERROR',
    //   detail = 'An unknown error occurred.',
    // } = generateCode?.response?.data;
    // yield put(
    //   generateCodeForDeviceFailure(errorData)
    // );
    console.log('fetchGeneratecodefordevice error', error);
  }
}

// Watch generate code for device saga
export function* watchGenerateCodeDeviceSagas(): Generator<any, void, unknown> {
  yield takeLatest(
    generateCodeForDeviceRequest.type,
    fetchGenerateCodeDeviceRequestSaga
  );
}
